import { reactive } from 'vue'

/**
 * Serviço de toasts globais.
 *
 * Uso:
 *   this.$toast.sucesso('Salvo com sucesso!')
 *   this.$toast.erro('Não foi possível salvar.')
 *   this.$toast.alerta('Atenção: divergência encontrada.')
 *   this.$toast.info('Sincronizando dados...')
 */

export type VarianteToast = 'sucesso' | 'erro' | 'alerta' | 'info'

export interface ItemToast {
  id: number
  mensagem: string
  variante: VarianteToast
}

const DURACAO_MS = 4_000

let _proximoId = 0
const _fila = reactive<ItemToast[]>([])
const _timers = new Map<number, ReturnType<typeof setTimeout>>()

function _agendarRemocao(id: number): void {
  const timer = setTimeout(() => removerToast(id), DURACAO_MS)
  _timers.set(id, timer)
}

export function removerToast(id: number): void {
  const idx = _fila.findIndex((t) => t.id === id)
  if (idx !== -1) _fila.splice(idx, 1)
  clearTimeout(_timers.get(id))
  _timers.delete(id)
}

export function pausarToast(id: number): void {
  const timer = _timers.get(id)
  if (timer !== undefined) {
    clearTimeout(timer)
    _timers.delete(id)
  }
}

export function retomarToast(id: number): void {
  if (_fila.some((t) => t.id === id)) {
    _agendarRemocao(id)
  }
}

/** Fila reativa de toasts ativos — use somente para leitura no template. */
export const filaToast: ItemToast[] = _fila

export const ServicoToast = {
  sucesso(mensagem: string): void {
    const id = ++_proximoId
    _fila.push({ id, mensagem, variante: 'sucesso' })
    _agendarRemocao(id)
  },

  erro(mensagem: string): void {
    const id = ++_proximoId
    _fila.push({ id, mensagem, variante: 'erro' })
    _agendarRemocao(id)
  },

  alerta(mensagem: string): void {
    const id = ++_proximoId
    _fila.push({ id, mensagem, variante: 'alerta' })
    _agendarRemocao(id)
  },

  info(mensagem: string): void {
    const id = ++_proximoId
    _fila.push({ id, mensagem, variante: 'info' })
    _agendarRemocao(id)
  },
}
